var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.versions.length > 1
    ? _c(
        "div",
        {
          staticClass: "history",
          class: { "st-open": _vm.isOpen },
          style: _vm.historyStyle,
        },
        [
          _c("p", [_vm._v("查看历史版本")]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "root",
              staticClass: "input--dropdown-select",
              class: { "st-open": _vm.isOpen },
            },
            [
              _c(
                "div",
                {
                  staticClass: "dropdown-select__layout",
                  style: _vm.layoutStyle,
                },
                [
                  _c(
                    "div",
                    {
                      ref: "transform",
                      staticClass: "dropdown-select__transform",
                      style: _vm.transformStyle,
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "display",
                          staticClass: "dropdown-select__display",
                          attrs: { role: "button", tabindex: "0" },
                          on: {
                            click: _vm.toggle,
                            keydown: [
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.toggle.apply(null, arguments)
                              },
                              function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "space",
                                    32,
                                    $event.key,
                                    [" ", "Spacebar"]
                                  )
                                )
                                  return null
                                $event.preventDefault()
                                return _vm.toggle.apply(null, arguments)
                              },
                            ],
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selected.label) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-select__option" }, [
                        _c(
                          "ul",
                          {
                            ref: "list",
                            staticClass: "dropdown-select__option__list",
                          },
                          _vm._l(_vm.versions, function (version) {
                            return _c(
                              "li",
                              {
                                key: version.value,
                                staticClass: "dropdown-select__option__item",
                                class: {
                                  "st-selected": version.value === _vm.value,
                                },
                                attrs: {
                                  role: "option",
                                  "aria-selected": version.value === _vm.value,
                                  tabindex: "0",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onSelect(version.value)
                                  },
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.onSelect(version.value)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "space",
                                          32,
                                          $event.key,
                                          [" ", "Spacebar"]
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.onSelect(version.value)
                                    },
                                  ],
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(version.label))])]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }